module.exports = __webpack_public_path__ + "img/python.cca0d4a4.jpg";